import React, { Component } from 'react';
import "./index.scss";

class Chart extends Component {

    render() {
        return (
            <div className="t7_2-chart">
                <div id="row1" className="t7_2-chart-content"></div>
            </div>
        );
    }
}

export default Chart;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-2/components/Chart.js